
import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { ExecutorInvitePayload, ExecutorInviteResponse } from '../../types';
import Cookies from 'js-cookie';
import { inviteExecutor } from '../estatelist/estateService';

interface AddExecutorModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: (executor: ExecutorInviteResponse) => void; // Callback to parent on successful invitation
  estateId: string; // Needed to call the API
}

const AddExecutorModal: React.FC<AddExecutorModalProps> = ({ open, onCancel, onSuccess, estateId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const token = Cookies.get('accessToken'); // Adjust if your token key is different
      if (!token) {
        message.error('Unauthorized. Please log in.');
        setLoading(false);
        onCancel();
        return;
      }

      const payload: ExecutorInvitePayload = {
        name: values.name,
        email: values.email,
      };

      const response: ExecutorInviteResponse = await inviteExecutor(estateId, payload, token);
      onSuccess(response);
      setLoading(false);
      form.resetFields();
      message.success(response.message);
      onCancel();
    } catch (error: any) {
      console.error(error);
      if (error.message === 'Unauthorized') {
        message.error('Unauthorized. Please log in.');
      } else {
        message.error(error.message || 'Failed to invite executor.');
      }
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Executor"
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Add Executor"
      cancelText="Cancel"
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Please enter the executor's name!" },
          ]}
        >
          <Input placeholder="Enter executor's name" />
        </Form.Item>
        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            { required: true, message: "Please enter the executor's email address!" },
            { type: 'email', message: 'Please enter a valid email address!' },
          ]}
        >
          <Input placeholder="Enter executor's email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddExecutorModal;
